export const formatNumber = (value) => Number(value || 0).toLocaleString();
